/**
 * @flow
 * @relayHash c656e4307e0e6884b5260481cce9adaa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AreaFilterParentSelectedAreaQueryVariables = {|
  input: string
|};
export type AreaFilterParentSelectedAreaQueryResponse = {|
  +savedArea: ?{|
    +id: string,
    +jsonid: ?string,
    +name: string,
  |}
|};
export type AreaFilterParentSelectedAreaQuery = {|
  variables: AreaFilterParentSelectedAreaQueryVariables,
  response: AreaFilterParentSelectedAreaQueryResponse,
|};
*/


/*
query AreaFilterParentSelectedAreaQuery(
  $input: ID!
) {
  savedArea(id: $input) {
    id
    jsonid
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "savedArea",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "input",
        "type": "ID!"
      }
    ],
    "concreteType": "SavedAreaNode",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "jsonid",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AreaFilterParentSelectedAreaQuery",
  "id": null,
  "text": "query AreaFilterParentSelectedAreaQuery(\n  $input: ID!\n) {\n  savedArea(id: $input) {\n    id\n    jsonid\n    name\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AreaFilterParentSelectedAreaQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "AreaFilterParentSelectedAreaQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '67e48b916d1691917506a4eceef30dfb';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/AreaFilterParent/__generated__/AreaFilterParentSelectedAreaQuery.graphql.js